module.exports = "../../../../platform/assets/pageMainIcon/simple_jichudanganlei7.svg";